import moment from 'moment';

/**
 * callback for chart.js tooltip title
 * returns the date in MMMM D format
 * @param  {Array} tooltipItem tooltip data
 * @return {String}             formatted date
 */
export default (tooltipItem) => {
    const date = moment(tooltipItem[0].xLabel, 'MMM D, YYYY');
    const display = date.format('MMMM D');
    return display;
};



// WEBPACK FOOTER //
// ./src/functions/chartTooltipDate.js